import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { NavDrawer } from './NavDrawer';
import { OfflineBanner } from '../OfflineBanner';
import { useLiveSettings } from '../../hooks/useLiveSettings';

export const AppLayout: React.FC = () => {
  const settings = useLiveSettings();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <NavDrawer />
      <Header brandName={settings?.brand_name} brandSubtitle={settings?.brand_subtitle} logoFile={settings?.logo_file} />
      <OfflineBanner />
      <Box component="main" sx={{ flex: 1, overflow: 'auto', bgcolor: 'background.default' }}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default AppLayout;
